"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const definitions_1 = require("./definitions");
const escrowcontract_1 = require("./escrowcontract");
class CustomSmartContractTransactionBuilder {
    static buildTransaction(input, json, chainId, fee, signerPubkey, config) {
        if (config.type === definitions_1.SmartContractType.EscrowSmartContract) {
            return escrowcontract_1.EscrowContract.buildTransaction(input, json, chainId, fee, signerPubkey, config);
        }
        else {
            throw new Error("unknown custom smart contract type");
        }
    }
}
exports.CustomSmartContractTransactionBuilder = CustomSmartContractTransactionBuilder;
//# sourceMappingURL=transactionbuilder.js.map